import { DOOR } from '../Constants/ObjectTypes';
import { getWrappedObject } from './constructionTools';

const blockSize = 1.25;
const defaultWallWidth = 5;

function snapToBlock(object, wall, options = {}) {
  const wallWidth = wall?.userData?.wallWidth || defaultWallWidth;
  const wallWidthHalf = wallWidth * 0.5;
  const wallRestWidth = wallWidth % blockSize;
  const wallX = object.userData.absoluteOffset ? (wall.wrapperObject || wall).position.x : 0;
  const wallOffset = wallX - wallWidthHalf;
  const localPosition = object.position.x - wallOffset;
  const objectWidthHalf = roundToDigits(object?.userData?.width) * 0.5;
  const xMax = wallOffset + wallWidth - wallRestWidth - objectWidthHalf;
  const xMin = wallOffset + objectWidthHalf;
  let snappedX = wallOffset + blockSize + Math.round((localPosition - blockSize) / blockSize) * blockSize;
  snappedX = Math.max(Math.min(snappedX, xMax), xMin);
  const otherObjectAtPosition = findBlockerObjectAtPosition(object, snappedX);
  if (otherObjectAtPosition) {
    if (options.addMode) {
      snappedX = otherObjectAtPosition.position.x + blockSize * 2;
      if (snappedX > xMax) {
        snappedX = otherObjectAtPosition.position.x - blockSize * 2;
      }
      if (snappedX < xMin) {
        snappedX = xMin;
        xMin < xMax && setObjectPosition(otherObjectAtPosition, xMax);
      }
    } else {
      object.position.x = object.userData.centerOffsetX;
      return;
    }
  }
  setObjectPosition(object, snappedX);
}

function findBlockerObjectAtPosition(object, x) {
  let result;
  const absoluteX = getAbsoluteX(object, x);
  const minX = absoluteX - blockSize;
  const maxX = absoluteX + blockSize;
  object.wall.traverse((obj) => {
    const objAbsoluteX = getAbsoluteX(obj);
    if (
      !result &&
      obj.warehouseObjectRef &&
      obj.warehouseObjectRef !== object.warehouseObjectRef &&
      objAbsoluteX >= minX &&
      objAbsoluteX <= maxX
    ) {
      result = obj;
    }
  });
  return result;
}

function roundToDigits(value, digits = 3) {
  const m = Math.pow(10, digits);
  return Math.round(value * m) / m;
}

function getAbsoluteX(object, x = object.position.x) {
  return object.wallSegment ? object.wallSegment.position.x + x : x;
}

function findOtherObjectAtPosition(object, x) {
  let result;
  const absoluteX = getAbsoluteX(object, x);
  object.wall.traverse((obj) => {
    if (
      !result &&
      obj.warehouseObjectRef &&
      obj.warehouseObjectRef !== object.warehouseObjectRef &&
      absoluteX === getAbsoluteX(obj)
    ) {
      result = obj;
    }
  });
  return result;
}

function setObjectPosition(object, x) {
  object.position.x = x;
  object.userData.centerOffsetX = x;
  if (object.warehouseObjectRef.absoluteOffset) {
    object.warehouseObjectRef.centerOffsetX = x;
  }
}

function snapToEnds(object, wall, options = {}) {
  const wallWidthHalf = (wall?.userData?.wallWidth || defaultWallWidth) * 0.5;
  const objectWidthHalf = roundToDigits(object?.userData?.width) * 0.5;

  const wallX = object.userData.absoluteOffset ? (wall.wrapperObject || wall).position.x : 0;
  let snappedX =
    wallX +
    (object.position.x > wallX ? 1 : -1) * (wallWidthHalf - objectWidthHalf) +
    (wallWidthHalf < objectWidthHalf ? (object.position.x > wallX ? 1 : -1) * wallWidthHalf : 0);
  const otherObjectAtPosition = findOtherObjectAtPosition(object, snappedX);
  if (otherObjectAtPosition) {
    if (options.addMode) {
      snappedX *= -1;
    } else {
      object.position.x = object.userData.centerOffsetX;
      return;
    }
  }
  setObjectPosition(object, snappedX);
}

function getWallSegmentAtPosition(wall, x) {
  const { wallSegmentsWidth = [], length } = getWrappedObject(wall).userData;
  const minPos = -length * 0.5;
  let pos = minPos;
  for (let i = 0; i < wallSegmentsWidth.length; i++) {
    pos += wallSegmentsWidth[i];
    if (pos >= x) {
      return getWrappedObject(wall.children[i]);
    }
  }
  return x < minPos
    ? getWrappedObject(wall.children[0])
    : getWrappedObject(wall.children[wallSegmentsWidth.length - 1]);
}

export function applySnap(object, options = {}) {
  if (!object || !object.userData?.snap) {
    return;
  }
  const { type } = object.userData;
  switch (type) {
    case DOOR: {
      const wall =
        getWrappedObject(object.wallSegment) || getWallSegmentAtPosition(object.wall, object.position.x);
      switch (wall?.userData?.wallType) {
        case 'wall_hard_plastic_white':
        case 'wall_glass': {
          return snapToBlock(object, wall, options);
        }
        default: {
          return snapToEnds(object, wall, options);
        }
      }
    }
  }
}
